import { AssetList } from '../../components';
import { useHaloScript } from '../../hooks/useHaloScript';

import type { ElemasonAssetListWidget } from '@tectonic/types';
import type { FC } from 'react';

interface ElemasonAssetListWidgetProps {
  widget: ElemasonAssetListWidget;
}

const AssetListWidget: FC<ElemasonAssetListWidgetProps> = ({
  widget: { data, config },
}) => {
  const { assets: assetsAccessor } = data ?? {};
  const assets = useHaloScript(assetsAccessor);

  if (!assets) return null;

  return (
    <div className="flex flex-col">
      <AssetList assets={assets} config={config} />
    </div>
  );
};

export { AssetListWidget };
